<template>
  <v-navigation-drawer v-model="visible" :clipped="$vuetify.breakpoint.lgAndUp" app>
    <v-list dense>
      <v-list-item to="/position-monitoring" link>
        <v-list-item-action>
          <v-icon>mdi-format-list-bulleted-type</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t('position-monitoring') }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/datacenter-check" link>
        <v-list-item-action>
          <v-icon>mdi-server-network</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t('datacenter-check') }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/url-monitoring" link>
        <v-list-item-action>
          <v-icon>mdi-list-status</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t('url-monitoring') }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>

     <!-- <v-alert
      text
      dense
      color="teal"
      :icon="false"
    >
      {{ $t('seo') }} <br> <a href="mailto:hello@check-position.com">hello@check-position.com</a>
    </v-alert> -->
    
    
    
    <v-subheader v-if="$account.isAdministrator">Gestion</v-subheader>
    <app-navigation-admin v-if="$account.isAdministrator"></app-navigation-admin>

    <v-subheader v-if="$account.isAdministrator">Technique</v-subheader>
    <app-navigation-technical v-if="$account.isAdministrator"></app-navigation-technical>

    <template v-slot:append>
      <app-navigation-footer></app-navigation-footer>
    </template>
  </v-navigation-drawer>
</template>

<style></style>

<script>
import AppNavigationAdmin from './AppNavigation/AppNavigationAdmin'
import AppNavigationTechnical from './AppNavigation/AppNavigationTechnical'
import AppNavigationFooter from './AppNavigation/AppNavigationFooter'

export default {
  name: 'AppNavigation',
  components: { AppNavigationAdmin, AppNavigationTechnical, AppNavigationFooter },
  computed: {
    visible: {
      get: function () {
        return this.$ui.navigation.visible
      },
      set: function (newValue) {
        this.$ui.navigation.visible = newValue
      }
    },
  }
}
</script>

<i18n>
{
	"en": {
		"datacenter-check": "Position by datacenter",
		"position-monitoring": "Position tracking",
		"url-monitoring": "URL indexing tracking",
		"seo": "SEO agency / freelancer? Would you like to be listed here ?"
	},
	"es": {
		"datacenter-check": "Posición por centro de datos",
		"position-monitoring": "Seguimiento de las posiciones",
		"url-monitoring": "Seguimiento de indexación de URL",
		"seo": "¿Agencia SEO/freelancer? ¿Te gustaría aparecer aquí?"
	},
	"fr": {
		"datacenter-check": "Position par datacenter",
		"position-monitoring": "Suivi des positions",
		"url-monitoring": "Suivi d'indexation d'URL",
		"seo": "Agence/Freelance SEO ? Vous souhaitez apparaître ici ?"
	},
	"it": {
		"datacenter-check": "Posizione per datacenter",
		"position-monitoring": "Monitoraggio posizioni",
		"url-monitoring": "Monitoraggio indicizzazione URL",
		"seo": "Agenzia/Freelance SEO? Vorresti essere elencato qui?"
	},
	"pt": {
		"datacenter-check": "Posição por datacenter",
		"position-monitoring": "Monitorização de posições",
		"url-monitoring": "Monitorização de indexação de URL",
		"seo": "Agência/Freelance SEO? Gostaria de aparecer aqui?"
	},
	"pl": {
		"datacenter-check": "Pozycja według centrum danych",
		"position-monitoring": "Śledzenie pozycji",
		"url-monitoring": "Śledzenie indeksacji URL",
		"seo": "Agencja SEO / freelancer? Chciałbyś być tu wymieniony?"
	}
}
</i18n>